import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isBrowser } from 'react-device-detect'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import BasicLayout from 'core/templates/BasicLayout'
import { Row, Col, ButtonPrimary, Card } from 'core/components/ui'
import * as routes from 'core/routing/constants/index'
import { FormattedMessage, injectIntl } from 'react-intl'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import SVG from 'core/components/svg'
import { greys } from 'assets/themes/theme-default' //font ,
import svg from 'assets/svg'

const StyledCard = styled(Card)`
  &&& {
    .ant-card-actions {
      background: ${greys.light3};
    }
  }
`

const RowCardWrappper = styled(Row)`
  margin-top: ${isBrowser ? '90px' : '50px'};
`

const StyledSVG = styled(SVG)`
  &&& {
    width: 34px;
    height: 34px;
    fill: ${greys.light4};
    vertical-align: middle;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -17px 0 0 -17px;
  }
`
const StyledSVGMobile = styled(SVG)`
  &&& {
    width: 30px;
    height: 30px;
    margin: 0 5px 0 0;
    fill: ${greys.light4};
    vertical-align: middle;
  }
`
const ButtonMobileWrapper = styled.div`
  margin: 0 0 25px 0;
  width: 100%;
`

const IconWrapper = styled.div`
  background: ${greys.dark1};
  color: ${greys.light4};
  border-radius: 60px;
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0;
  left: 50%;
  margin: -30px 0 0 -30px;
`

// eslint-disable-next-line react/prop-types
const TitleWrapper = ({ title, icon }) => (
  <div style={{ paddingTop: '15px' }}>
    <IconWrapper>
      <StyledSVG svg={icon} />
    </IconWrapper>
    {title}
  </div>
)

const Home = props => {
  const {
    intl,
    resetConfigurator,
    resetTradeIn,
    resetStock,
    resetConfiguratorWizard,
    resetStockWizard
  } = props

  const handleClick = route => {
    const { history } = props
    history.push(route)
  }

  const RenderCard = prop => {
    const { title, icon, actions, body } = prop

    return (
      <>
        {isBrowser ? (
          <Col lg={8} sm={24}>
            <StyledCard
              onClick={() => handleClick(actions.route)}
              hoverable
              bordered={false}
              title={<TitleWrapper title={title} icon={icon} />}
              actions={[<ButtonPrimary>{actions.label}</ButtonPrimary>]}
            >
              {isBrowser && body}
            </StyledCard>
          </Col>
        ) : (
          <ButtonMobileWrapper>
            <ButtonPrimary block onClick={() => handleClick(actions.route)}>
              <StyledSVGMobile svg={icon} /> {title}
            </ButtonPrimary>
          </ButtonMobileWrapper>
        )}
      </>
    )
  }

  useEffect(() => {
    resetConfigurator()
    resetTradeIn()
    resetStock()

    resetConfiguratorWizard()
    resetStockWizard()
  }, [])

  return (
    <BasicLayout data-test="component-home" showSider={false}>
      <MainContentWrapper
        title={intl.formatMessage({
          id: 'home-view-title'
        })}
      >
        <RowCardWrappper type="flex" justify="center" gutter={16}>
          <RenderCard
            title={intl.formatMessage({
              id: 'home-card1-title'
            })}
            icon={svg.gears}
            actions={{
              route: routes.CONFIGURATOR,
              label: intl.formatMessage({
                id: 'home-cta-1'
              })
            }}
            body={<FormattedMessage id="home-card1-body" />}
          />

          <RenderCard
            title={intl.formatMessage({
              id: 'home-card2-title'
            })}
            icon={svg.light}
            actions={{
              route: routes.STOCK,
              label: intl.formatMessage({
                id: 'home-cta-2'
              })
            }}
            body={<FormattedMessage id="home-card2-body" />}
          />

          <RenderCard
            title={intl.formatMessage({
              id: 'home-card3-title'
            })}
            icon={svg.refresh}
            actions={{
              route: routes.TRADEIN,
              label: intl.formatMessage({
                id: 'home-cta-3'
              })
            }}
            body={<FormattedMessage id="home-card3-body" />}
          />
        </RowCardWrappper>
      </MainContentWrapper>
    </BasicLayout>
  )
}

Home.propTypes = {
  intl: PropTypes.shape().isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  resetConfigurator: PropTypes.func.isRequired,
  resetTradeIn: PropTypes.func.isRequired,
  resetStock: PropTypes.func.isRequired,
  resetConfiguratorWizard: PropTypes.func.isRequired,
  resetStockWizard: PropTypes.func.isRequired
}

export default withRouter(injectIntl(Home))
